// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
 * Sits in the palette footer, above the "Browse … Catalog +" button, on the
 * dark panel all three palettes share.
 */
.QpIIGtSNLxbHlU9xNkqc {
  margin: 0 0 8px;
  font-family: var(--curio-font-family);
  font-size: 11px;
  line-height: 1.4;
  /* Quiet against the dark panel: it is a standing instruction, not news, and
     must not compete with the rows above it or the catalog button below. */
  color: rgba(255, 255, 255, 0.55);
}
`, "",{"version":3,"sources":["webpack://./src/components/menus/nodes/PaletteDragHint.module.css"],"names":[],"mappings":"AAAA;;;EAGE;AACF;EACE,eAAe;EACf,qCAAqC;EACrC,eAAe;EACf,gBAAgB;EAChB;2EACyE;EACzE,gCAAgC;AAClC","sourcesContent":["/*\n * Sits in the palette footer, above the \"Browse … Catalog +\" button, on the\n * dark panel all three palettes share.\n */\n.hint {\n  margin: 0 0 8px;\n  font-family: var(--curio-font-family);\n  font-size: 11px;\n  line-height: 1.4;\n  /* Quiet against the dark panel: it is a standing instruction, not news, and\n     must not compete with the rows above it or the catalog button below. */\n  color: rgba(255, 255, 255, 0.55);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"hint": `QpIIGtSNLxbHlU9xNkqc`
};
export default ___CSS_LOADER_EXPORT___;
